import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { urlObjectToStrings, getCookie } from './../../assets/js/utils'
import Popup from './../popup'
import './index.less'

class InvitePanel extends Component {
  static propTypes = {
      data: PropTypes.object
  };

  constructor (props) {
      super(props)
      this.state = {
      // 是否登录
          isLogin: false,
          // 是否显示弹窗
          isShowPopup: false
      }
  }

  UNSAFE_componentWillMount () {
      const sessionId = getCookie('sessionId')
      const isPreview = new URLSearchParams(window.location.search).get('isPreview')
      if (sessionId || isPreview) {
          this.setState({
              isLogin: true
          })
      }
  }

  /**
   * 显示弹窗
   */
  showPopup = () => {
      this.setState({
          isShowPopup: true
      })
  };

  /**
   * 关闭弹窗
   */
  closePopup = () => {
      this.setState({
          isShowPopup: false
      })
  };

  // 页面跳转
  handleJump (url, businessLines, eventCode, trackId) {
      if (!url) {
          return
      }
      const newUrl = urlObjectToStrings(url, {
          businessLines: businessLines || '',
          eventCode: eventCode || ''
      })
      window.location.href = newUrl
  }

  render () {
      const { isLogin, isShowPopup } = this.state
      const { data: { position, style = {}, sublist, titleTip = '' }, buriedPointEvent } = this.props
      const {
          backgroundPicUrl = '',
          backgroundColor = '',
          cardBackgroundPicUrl = '',
          cardBackgroundColor = '',
          textColor = ''
      } = style

      return (
          <Fragment>
              {isLogin && (
                  <div
                      className="invite-panle"
                      style={{
                          backgroundColor: backgroundColor,
                          backgroundImage: `url(${backgroundPicUrl || ''})`
                      }}
                  >
                      <div
                          className="invite-content"
                          style={{
                              backgroundColor: cardBackgroundColor,
                              backgroundImage: `url(${cardBackgroundPicUrl || ''})`
                          }}
                      >
                          {sublist.map(
                              ({ title, total, url, buttonImageUrl, businessLines, eventCode, trackId, id }, index) => {
                                  return (
                                      <div
                                          className="item statistics-dom"
                                          key={id}
                                          onClick={() =>
                                              buriedPointEvent({
                                                  button_name: `${this.props.data.trackId}-${title}`,
                                                  button_id: `${id}`,
                                                  button_order: `${index + 1}`,
                                                  area_order: position,
                                                  button_area: `${position}-${this.props.data.trackId}`
                                              })
                                          }
                                      >
                                          <p style={{ color: `${textColor}` }}>{title}</p>
                                          <h3 style={{ color: `${textColor}` }}>{total || '--'}</h3>
                                          <img
                                              className="btn-img"
                                              src={buttonImageUrl}
                                              alt=""
                                              onClick={() => {
                                                  this.handleJump(url, businessLines, eventCode, trackId)
                                              }}/>
                                      </div>
                                  )
                              }
                          )}
                          <i className="icon icon-problem" onClick={this.showPopup} />
                      </div>
                  </div>
              )}
              <Popup
                  titleText="邀请说明"
                  btnText="知道了"
                  isShowPopup={isShowPopup}
                  closePopup={this.closePopup}
              >
                  <div className="text">
                      {titleTip && titleTip.split('/n').map((item, index) => {
                          return (<p key="index">{item}</p>)
                      })}
                  </div>
              </Popup>
          </Fragment>
      )
  }
}

export default InvitePanel
